




import { Component, Vue } from "vue-property-decorator";
import { Button } from "vant";

@Component({
  name: 'FaceResult',
  components: {
    [Button.name]: Button
  }
})
export default class FaceResult extends Vue {
  isSuccess = true;
  video = "";
  photo = "";
  created() {
    setTimeout(this.handleProcessResult, 1000);
  }

  handleProcessResult() {
    const { orderNo, code } = this.$route.query;
    const params = {
      order_no: orderNo
    };
    (this as any).$apis
      .verifyFaceResult(params)
      .then(res => {
        
      })
      .catch(e => {
        
      });
    if (code == "0") {
      this.$router.replace({
        path: "/face-success",
        query: {
          open_status: "1",
          order_no: orderNo,
          verify_action: "1"
        }
      });
    } else {
      this.$router.replace({
        path: "/face-fail",
        ["query" as any]: {
          tip: this.$t("face_recognition.verify_fail_msg"),
          order_no: orderNo,
          open_status: "1",
          isTwoBtn: "1"
        }
      });
    }
  }
}
